import React, { useEffect, useState, useRef } from 'react'
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { ProgressSpinner } from 'primereact/progressspinner';
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';

import { useRetrieveMediaDuration, useUpdateMediaDuration } from '../../../../queries';
import { formatDuration } from '../../../../config/global';
import { useCustomToast } from '../../../Contexts/ToastContext';

function MediaDuration({ item, isDarkMode = false }) {
    const { t } = useTranslation();
    const retrieveMediaDuration = useRetrieveMediaDuration()
    const updateMediaDuration = useUpdateMediaDuration()
    const loading = retrieveMediaDuration.isLoading || updateMediaDuration.isLoading
    const { showToast } = useCustomToast();

    const [editDuration, setEditDuration] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState("");
    const [duration, setDuration] = useState(item.total_duration);
    const previousDuration = useRef(item.total_duration);
    const [send, setSend] = useState(false);

    const sendOnkeypress = (e) => {
        setEditDuration(false)
        setSend(true)
    }

    const retrieveDefaultValue = async () => {
        await retrieveMediaDuration.mutateAsync({
            id: item.campaign_playlist_media_id
        }, {
            onSuccess: (result) => {
                showToast('success', t('dragdrop.retrieve_media_duration'), result?.msg);
                setEditDuration(false)
            }
        })
    }

    const editDurationHandle = () => {
        if (!JSON.parse(sessionStorage.getItem('is_default_prayer'))) {
            setSelectedMedia(item.id)
            setEditDuration(true)
        }
    }

    // Duration Handler
    useEffect(() => {
        if (send && previousDuration.current != duration) {
            updateHandler()
        }
        setSend(false)
    }, [send])

    const updateHandler = async () => {
        if (previousDuration.current != duration) {
            await updateMediaDuration.mutateAsync({
                id: item.campaign_playlist_media_id,
                data: {
                    "total_duration": duration,
                    "layer": item.layer
                }
            }, {
                onSuccess: () => {
                    setEditDuration(false);
                    previousDuration.current = duration
                }
            })
        } else {
            setEditDuration(false)
        }
    }

    return (
        <>
            {
                editDuration ?
                    <div className=' d-flex align-items-center justify-content-center'>
                        <InputNumber inputId="minmax" mode="decimal"
                            value={item.total_duration}
                            onValueChange={(e) => setDuration(e.value)}
                            onChange={(e) => setDuration(e.value)}
                            onKeyDown={(e) => e.key === 'Enter' ? sendOnkeypress(e) : ""}
                            min={1}
                            max={86399} //   (23:59:59)
                            className="duration_input" />

                        {
                            loading && selectedMedia === item.id ?
                                <div className="cursor-pointer  text-center" >
                                    <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="3" fill="var(--surface-ground)" animationDuration="2s" />
                                </div>
                                :

                                <div className="d-flex flex-column">
                                    <Tooltip target={`.save_duration-${item.id}`} content={t('dragdrop.save_changes')} position='bottom' className='fs-8' />
                                    <i className={`col-1 mx-2 fas fa-check-circle mb-2 cursor-pointer save_duration-${item.id} ${isDarkMode ? 'text-indigo-400' : 'text-indigo-600'}`}
                                        onClick={updateHandler}></i>
                                    <Tooltip target={`.retrieve_duration-${item.id}`} content={t('dragdrop.retrieve_duration')} position='bottom' className='fs-8' />
                                    <i className={`col-1 mx-2 fas fa-redo cursor-pointer retrieve_duration-${item.id} ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`} onClick={retrieveDefaultValue}> </i>
                                </div>
                        }
                    </div>
                    :
                    (_.isNull(item.media_id)) ?
                        <div className={`text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            {!_.isNull(item.playlist_id) ? formatDuration(item.playlist_duration) : formatDuration(item.layout_duration)}
                        </div>
                        :
                        loading && selectedMedia === item.id ?
                            <div className="cursor-pointer  text-center" >
                                <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="3" fill="var(--surface-ground)" animationDuration="2s" />
                            </div>
                            :
                            <>
                                <Tooltip target={`.edit_duration-${item.id}`} content={t('dragdrop.edit_duration')} position='bottom' className="fs-8" hideDelay={300} />
                                <div className={`edit_duration-${item.id} cursor-pointer  text-center ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}
                                    onClick={editDurationHandle}>
                                    {formatDuration(item.total_duration)}
                                </div>
                            </>
            }
        </>
    )
}

export default MediaDuration